import React from "react";

const ClubIcon = (props: any) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.03789 18.6808L9.08535 18.5928L9.36933 18.0661L9.4168 17.9781L9.32876 17.9307L8.10961 17.2735C8.1096 17.2735 8.10959 17.2735 8.10959 17.2735C6.67633 16.5004 5.78633 15.0093 5.78633 13.3808V3.72363V3.62363H5.68633H5.08789H4.98789V3.72363V13.3808C4.98789 15.3032 6.03901 17.0637 7.73067 17.9761L7.73069 17.9761L8.94988 18.6333L9.03789 18.6808Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.2"
      />
      <path
        d="M7.04023 16.626V16.526H6.94023H6.3418H6.2418V16.626V21.5043V21.6043H6.3418H6.94023H7.04023V21.5043V16.626Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.2"
      />
      <path
        d="M8.72578 17.8652V17.7652H8.62578H8.02734H7.92734V17.8652V21.5032V21.6032H8.02734H8.62578H8.72578V21.5032V17.8652Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.2"
      />
      <path
        d="M17.7951 16.626V16.526H17.6951H17.0967H16.9967V16.626V21.5043V21.6043H17.0967H17.6951H17.7951V21.5043V16.626Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.2"
      />
      <path
        d="M16.1115 17.8652V17.7652H16.0115H15.4131H15.3131V17.8652V21.5032V21.6032H15.4131H16.0115H16.1115V21.5032V17.8652Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.2"
      />
      <path
        d="M12.2108 20.0376L12.2575 20.126L12.3459 20.0792L16.3206 17.9765L16.3213 17.9761C18.013 17.0638 19.0641 15.3032 19.0641 13.3808V3.72363V3.62363H18.9641H18.3657H18.2657V3.72363V13.3808C18.2657 15.0092 17.3758 16.5003 15.9449 17.2722C15.9448 17.2723 15.9447 17.2723 15.9446 17.2724L11.9728 19.3736L11.8844 19.4204L11.9311 19.5088L12.2108 20.0376Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.2"
      />
      <path
        d="M13.7079 12.7944L12.4213 12.1092C12.277 12.0323 12.1055 12.0344 11.9634 12.1133L11.9633 12.1134L10.6896 12.8218L10.9435 11.3863L10.9435 11.3862C10.9716 11.2256 10.9173 11.0631 10.7978 10.9519L10.7978 10.9519L9.73028 9.95905L11.1735 9.75702C11.1735 9.75701 11.1736 9.757 11.1737 9.75699L11.1739 9.75697L11.16 9.65793C11.2878 9.64052 11.3966 9.56 11.451 9.44249M13.7079 12.7944L11.5418 9.48458L11.5417 9.48463L11.451 9.44249M13.7079 12.7944L13.4279 11.3638M13.7079 12.7944L13.4279 11.3638M11.451 9.44249L11.5418 9.4845L12.1577 8.15894M11.451 9.44249L12.1009 8.04379L12.1577 8.15894M12.1577 8.15894L12.2118 8.04251M12.1577 8.15894L12.7291 9.31805L12.7732 9.40771L12.8629 9.36356L13.3999 9.09916L13.4896 9.05496L13.4454 8.96523L12.58 7.20947L12.4901 7.2533M12.2118 8.04251L11.8057 7.25928L11.715 7.21723C11.7933 7.04842 11.9588 6.94142 12.145 6.94004L12.1458 6.94004L12.1496 6.94004C12.3343 6.94004 12.499 7.04352 12.5799 7.20926L12.5798 7.20909L12.4901 7.2533M12.2118 8.04251L12.8187 9.27384L13.266 9.05362L13.266 9.05365L13.3556 9.0095L13.3557 9.00944L13.3115 8.91973L13.3115 8.91974L12.4901 7.2533M12.2118 8.04251L12.1458 7.04004H12.1496C12.2959 7.04004 12.426 7.12164 12.4901 7.2533M10.1936 13.9024L10.1686 13.8528L10.1681 13.8517L10.2574 13.8067C10.1802 13.8067 10.104 13.7828 10.0376 13.7355L10.8915 8.9903L8.95476 9.26131L8.95463 9.26132C8.7704 9.28735 8.61994 9.41407 8.56422 9.592C8.50798 9.76986 8.55847 9.95961 8.69488 10.0864L10.1266 11.4181L9.78634 13.343L9.88477 13.3606L9.7863 13.3432L9.78631 13.3431C9.75342 13.5271 9.82806 13.7086 9.97948 13.8168L9.97958 13.8169C10.0446 13.8633 10.1178 13.8921 10.1936 13.9024ZM10.1936 13.9024L10.1963 13.9078H10.258C10.3385 13.9078 10.4182 13.887 10.4907 13.847L10.491 13.8468L12.1996 12.8962M10.1936 13.9024L12.1996 12.8962M12.1996 12.8962L13.9256 13.815C14.0902 13.9028 14.2862 13.8884 14.436 13.7771C14.5854 13.666 14.6565 13.4827 14.6208 13.3001L14.6208 13.3001L14.245 11.3813L15.6524 10.0237L15.7244 9.95425L15.655 9.88228L15.2393 9.45141L15.1699 9.37944L15.0979 9.44886L13.5656 10.9268C13.5655 10.9268 13.5655 10.9269 13.5655 10.9269C13.4479 11.0398 13.3963 11.2037 13.4279 11.3638M12.1996 12.8962L13.4279 11.3637L13.4279 11.3638"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.2"
      />
      <path
        d="M19.8435 3.4248V3.3248H19.7435H4.28906H4.18906V3.4248V4.02324V4.12324H4.28906H19.7435H19.8435V4.02324V3.4248Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.2"
      />
      <path
        d="M1.88047 3.72397C1.88047 4.49841 2.51008 5.12803 3.28452 5.12803C4.05896 5.12803 4.68857 4.49841 4.68857 3.72397C4.68857 2.94953 4.05896 2.31992 3.28452 2.31992C2.51008 2.31992 1.88047 2.94953 1.88047 3.72397ZM2.67891 3.72397C2.67891 3.39021 2.95076 3.11836 3.28452 3.11836C3.61827 3.11836 3.89013 3.39021 3.89013 3.72397C3.89013 4.05773 3.61827 4.32959 3.28452 4.32959C2.95076 4.32959 2.67891 4.05773 2.67891 3.72397Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.2"
      />
      <path
        d="M19.3443 3.72397C19.3443 4.49841 19.9739 5.12803 20.7484 5.12803C21.5228 5.12803 22.1524 4.49841 22.1524 3.72397C22.1524 2.94953 21.5228 2.31992 20.7484 2.31992C19.9739 2.31992 19.3443 2.94953 19.3443 3.72397ZM20.1428 3.72397C20.1428 3.39021 20.4146 3.11836 20.7484 3.11836C21.0821 3.11836 21.354 3.39021 21.354 3.72397C21.354 4.05773 21.0821 4.32959 20.7484 4.32959C20.4146 4.32959 20.1428 4.05773 20.1428 3.72397Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.2"
      />
    </svg>
  );
};

export default ClubIcon;
